import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import StrategySubjectDetail from '@app/views/ProjectStrategy/Detail';
import { memo } from 'react';

export default memo(
  withIfUser(StrategySubjectDetail)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
